import { SocketProvider, useSetupGlobalEvents } from "@/context/socket";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppHeader } from "@/components/dashboard/app-header";
import { ProtectedLayout } from "@/components/layout/protected";
import { ResponsiveSidebar } from "@/components/layout/sidebar";
import { ResponsiveMain } from "@/components/layout/main";
import { ResponsiveHeader } from "@/components/layout/header";

export const Route = createFileRoute("/dashboard/governance/_layout")({
  component: IntelligenceLayout,
});

function IntelligenceLayout() {
  useSetupGlobalEvents();

  return (
    <ProtectedLayout mode="dashboard">
      <SocketProvider>
        <ResponsiveSidebar />
        <ResponsiveMain>
          <ResponsiveHeader>
            <AppHeader />
          </ResponsiveHeader>
          <main className="py-6 pt-0 flex-1 w-full overflow-y-auto">
            <div className="w-full max-w-8xl mx-auto px-4 lg:px-10">
              <Outlet />
            </div>
          </main>
        </ResponsiveMain>
      </SocketProvider>
    </ProtectedLayout>
  );
}
